"use client";

import { type ReactNode, useState } from "react";
import { X } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

interface ImageLightboxProps {
  children: ReactNode;
  /** The full content to render inside the lightbox (image + overlays). */
  lightboxContent: ReactNode;
}

export function ImageLightbox({ children, lightboxContent }: ImageLightboxProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="block w-full cursor-zoom-in text-left"
      >
        {children}
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="flex h-[100dvh] max-h-none w-screen max-w-none items-center justify-center border-none bg-black/95 p-0 [&>button]:hidden">
          <DialogTitle className="sr-only">Enlarged image</DialogTitle>

          <button
            type="button"
            onClick={() => setOpen(false)}
            className="absolute right-4 top-4 z-50 flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white/80 backdrop-blur transition-colors hover:bg-white/20"
            aria-label="Close"
          >
            <X className="h-5 w-5" />
          </button>

          <div
            className="relative flex h-full w-full items-center justify-center p-4 sm:p-8"
            onClick={() => setOpen(false)}
          >
            <div
              className="relative h-full w-full"
              onClick={(e) => e.stopPropagation()}
            >
              {lightboxContent}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
